import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    bubbleWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        maxWidth: '90%', // AI/客服消息允许更大的宽度
    },
    bubbleWrapperRight: {
        flexDirection: 'row-reverse',
        maxWidth: '75%', // 用户消息保持较小宽度
    },
    bubble: {
        paddingHorizontal: 12,
        paddingVertical: 10,
        flexShrink: 1,
    },
    bubbleText: {
        fontSize: 15,
        lineHeight: 22,
    },
    cursor: {
        color: '#007AFF',
        fontSize: 15,
    },
    // 系统消息
    systemContainer: {
        alignItems: 'center',
        paddingVertical: 8,
        paddingHorizontal: 40,
    },
    systemText: {
        fontSize: 12,
        color: '#999999',
        textAlign: 'center',
        backgroundColor: '#F2F2F7',
        paddingHorizontal: 12,
        paddingVertical: 4,
        borderRadius: 4,
        overflow: 'hidden',
    },
    // 状态按钮（失败/已读/未读）
    statusButton: {
        width: 24,
        height: 24,
        borderRadius: 12,
        justifyContent: 'center',
        alignItems: 'center',
    },
    statusButtonFailed: {},
    statusButtonRead: {},
    statusButtonLeft: {
        marginRight: 6,
    },
    statusButtonRight: {
        marginLeft: 6,
    },
    loadingContainer: {
        paddingVertical: 4,
        paddingHorizontal: 8,
    },
});
